import React from "react";
import "./header.css"


function Header(props) {
return (
<>
  <header>
    <div className="container-lg d-flex align-items-center justify-content-between position-relative">
      <div className="d-flex align-items-center header-logo">
        <a href="/">
          <img src="dist/img/icici_logo.webp" alt="ICICI Bank Logo" width="252" height="50" className="img-fluid" />
        </a>
        <span>|</span>
        <span>Senior Citizen Solutions</span>
      </div>
    </div>
  </header>
</>
);
}

export default Header;